import type { IconSvgObject } from './types';

const ZodiacAriesIcon: IconSvgObject = [
  ["path", { d: "M11.9999 20V18.3309M11.9999 18.3309C11.9999 13.8055 10.8323 9.34991 8.6101 5.38638C7.72498 3.80769 5.53616 3.52069 4.26307 4.81821C3.47195 5.6245 3.27535 6.82962 3.77032 7.83856L4.24004 8.79602M11.9999 18.3309C11.9999 13.8055 13.1677 9.34991 15.3899 5.38638C16.275 3.80769 18.4638 3.52069 19.7369 4.81821C20.528 5.6245 20.7247 6.82962 20.2297 7.83856L19.76 8.79602", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ZodiacAriesIcon;
